import EnvChecker from "@/src/util/class/EnvChecker";
import { APP_ONE_LINK } from '../enum/Constants';
import { firebaseInit } from './firebase';
import { isIOS, openDialog } from './utils';
import '../../public/static/css/reset.css';
import '../../public/static/css/base.css';
import '../../public/static/css/common.css';
import '../../public/static/css/etc.css';
var goToWeb = function () {
    window.location.href = '/';
};
var goAppLink = function () {
    if (isIOS()) {
        openDialog('iOS 앱은 준비중입니다.', goToWeb);
    }
    else {
        var search = window.location.search || '?pid=""';
        window.open("".concat(APP_ONE_LINK).concat(search, "&is_retargeting=true"), '_self');
    }
};
var handleTagChange = function (e) {
    if (!e.target) {
        return;
    }
    var target = e.target;
    if (target.dataset.index !== undefined) {
        var index = Number(target.dataset.index);
        var other = index === 0 ? 1 : 0;
        var list = document.getElementsByClassName('promotion-box');
        if (list[index]) {
            list[index].style.display = 'block';
        }
        if (list[other]) {
            list[other].style.display = 'none';
        }
    }
};
var initialize = function () {
    if (!EnvChecker.isMobile()) {
        window.location.href = 'join_pc.html';
        return;
    }
    firebaseInit();
    var btn = document.getElementById('download-btn');
    if (btn) {
        btn.addEventListener('click', goAppLink);
    }
    document.addEventListener('click', handleTagChange);
};
initialize();
